import React, { useEffect } from 'react';

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/flow/icn_Flow-03.png';
import icn_02 from '../../assets/img/landingPage/vision/vision_03_realtime.svg';
import icn_03 from '../../assets/img/logos/icono_DS.svg';
import icn_04 from '../../assets/img/logos/icono_commander.svg';
import icn_05 from '../../assets/img/logos/icono_Vision.svg';
import icn_06 from '../../assets/img/logos/icono_brunix.svg';
import icn_07 from '../../assets/img/landingPage/cloud/KeyBeneffits_Cloud-01.svg';
import icn_08 from '../../assets/img/landingPage/eda/icn_eda-01.png';


import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';


const EdaRTE = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Virtual-first architecture',
            text: " Run and manage APIs in virtualized environments without disrupting production.",
            altDescription: " Run and manage APIs in virtualized environments without disrupting production.",
            image: product_gateway,
        },
        Key_Feature_02: {
            title: "AI-powered automation",
            text: "Smart recommendations for configuration, monitoring, and adaptive security.",
            altDescription: "Smart recommendations for configuration, monitoring, and adaptive security.",
            image: product_gateway,
        },
        Key_Feature_03: {
            title: 'Granular security and access control',
            text: "Apply policies by user, client, environment, or geographic region.",
            altDescription: 'Apply policies by user, client, environment, or geographic region.',
            image: product_gateway,
        },
        Key_Feature_04: {
            title: 'Advanced monitoring and analytics',
            text: 
            "Custom dashboards for real-time operational and business metrics.",
            altDescription: 'Custom dashboards for real-time operational and business metrics.',
            image: product_gateway,
        },
        Key_Feature_05: {
            title: '100% API-exposed functionality',
            text: 
            " Full control and deep integration via AVAP’s comprehensive API layer.",
            altDescription: ' Full control and deep integration via AVAP’s comprehensive API layer.',
            image: product_gateway,
        },
    }
    

    
    const items = [
        {
          icon: icn_01,
          title: 'Event-Driven Architecture (EDA)',
          paragraphs: [
            'EDA is a modern architectural style where events, state changes, user actions, system notifications, serve as the primary triggers that drive data flows and processing. Instead of relying on synchronous calls or sequential processes, EDA enables decoupled, asynchronous, and highly scalable systems.',
          ],
          paragraphs2: [
            'Key components include:',
          ],
          bullets: [
            'Producers: Emit events (e.g., an API receives an order).',
            'Event Brokers: Middleware distributing events reliably (Kafka, MQTT, NATS).',
            'Consumers: Subscribe and react to events with business logic.',
            'Event Stores: Persist events for traceability and replay.'
          ],
          paragraphs3: [
            'This powers resilient systems with low latency, ease of adding new capabilities without disrupting existing components, and is ideal for AI, automation, IoT, and microservices.',
          ],
          
        },
        {
          icon: icn_02,
          title: 'Real-Time Enterprise (RTE)',
          paragraphs: [
            'A Real-Time Enterprise detects, analyzes, and reacts to events immediately, without waiting for batch jobs or manual processes. It transforms data into automated, instant action using:',
          ],
          paragraphs2: [
            '',
          ],
          bullets: [
            'Event-driven architectures.',
            'Real-time iPaaS workflows.',
            'AI for automated decision-making.',
            'IoT devices and digital twins.',
            'Dynamic orchestration without manual intervention.',
            
          ],
          paragraphs3: [
            'RTEs compete by acting faster, smarter, and more autonomously.',
          ],
        },
      ];
      
    const breakpointColumnsObj = {
        default: 2, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };

    //Key UseCases Bento
    const items2 = [
        {
            icon: icn_03,
            title: '',
            paragraphs: [
              'Create event-generating and event-reactive APIs using AVAP Dev Studio and the AVAP language.'
            ]
          },
        {
            icon: icn_04,
            title: '',
            paragraphs: [
              'Integrate and orchestrate event flows seamlessly via AVAP Commander and iPaaS connectors.'
            ]
          },
        {
          icon: icn_05,
          title: '',
          paragraphs: [
            'Visualize real-time workflows and system health with AVAP Mesh Manager and AVAP Vision.',
          ]
        },
        {
            icon: icn_06,
            title: '',
            paragraphs: [
              'Automate event-driven decisions powered by Brunix AI and AVAP Virtual Server.',
            ]
          },
          {
            icon: icn_07,
            title: '',
            paragraphs: [
              'Route enriched contextual events using the Multipoint Contextual Protocol (MCP).'
            ]
          },     
          {
            icon: icn_08,
            title: '',
            paragraphs: [
              'Support hybrid event models by combining APIs and events in unified, governed, and flexible workflows.'
            ]
          },   
         
      ];
      
    const breakpointColumnsObj2 = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };

     //Key UseCases Bento
     const items3 = [
        {
            icon: icn_03,
            title: '',
            paragraphs: [
              'Create event-generating and event-reactive APIs using AVAP Dev Studio and the AVAP language.'
            ]
          },
        {
            icon: icn_04,
            title: '',
            paragraphs: [
              'Integrate and orchestrate event flows seamlessly via AVAP Commander and iPaaS connectors.'
            ]
          },
        {
          icon: icn_05,
          title: '',
          paragraphs: [
            'Visualize real-time workflows and system health with AVAP Mesh Manager and AVAP Vision.',
          ]
        },
        {
            icon: icn_06,
            title: '',
            paragraphs: [
              'Automate event-driven decisions powered by Brunix AI and AVAP Virtual Server.',
            ]
          },
          {
            icon: icn_07,
            title: '',
            paragraphs: [
              'Route enriched contextual events using the Multipoint Contextual Protocol (MCP).'
            ]
          },         
         
      ];
      
    const breakpointColumnsObj3 = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };
      

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">

                    <h1 className="fl-title-big m-0 fl-txt-container-s">Event-Driven Architecture & Real-Time Enterprises</h1>
                    <p className="fl-title m-0 gradient-text fl-txt-container-s">Real-time APIs. Event-first architecture. Build the reactive enterprise with AVAP.</p>
                                {/*<p className="fl-text fl-txt-container" >
                                Empower every team to automate work faster and smarter with AVAP Framework’s virtual-first, low-code platform — 
                                built to orchestrate tasks, data, and systems for both humans and AI agents.
                                </p>*/}
                </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    {/*<img
                        src={dashboard}
                        className="img-fluid mt-2 mb-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}                 
                    <h2 className="fl-subtitle pt-8">From APIs to events, AVAP makes your business responsive by design.</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    Event-Driven Architecture (EDA) and Real-Time Enterprises (RTE) are revolutionizing how organizations operate by enabling instant, intelligent reactions to business events as they happen. Moving beyond traditional synchronous systems, EDA leverages asynchronous, decoupled event flows to build scalable, resilient, and adaptive digital platforms. Coupled with real-time decision-making and automation, this approach empowers businesses to deliver faster, smarter experiences while increasing operational agility and innovation. </p>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Framework provides the native tools and architecture needed to design, orchestrate, and govern event-driven systems that respond in real time, turning data into immediate, actionable insight.</p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                   
        
                    
                    {/*<h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Why AVAP for Cloud Providers?</h2>

                   
                        <ul className="fl-bullets fl-text text-center .fl-txt-container-s">
                        <li className="fl-bullets">Expand your service offering with high-value API Management</li>
                        <li className="fl-bullets">Increase average revenue per customer with integrated, add-on services</li>
                        <li className="fl-bullets">Provide full-featured API monitoring, control, and security</li>
                        <li className="fl-bullets">Deliver everything under your brand with flexible integration options</li>
                        <li className="fl-bullets">Maintain complete control of customer experience and business model</li> </ul>*/}
                        
                </section>

               
                {/*<section className="container py-5 fl-gradientContainer mb-5" >
                <p className="fl-title-center m-0">Two Deployment Models</p><br />
                <p className="fl-subtitle text-center m-0 gradient-text">One Scalable Platform.</p>
            
                &nbsp;
                <br />&nbsp;    
                 <div className="row">
                        <div className="col-md-6 d-flex">
                            <img
                                src={icn_vision}
                                alt="Icon representing vision."
                                className="aboutIcon"
                            
                            />
                            <h3 className="fl-subtitle">1. Direct Provider Model</h3>
                            <p className="fl-text">
                            Integrate AVAP API Management directly into your platform via service APIs:
                            </p>
                                
                                <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">White-label the solution under your own brand</li>
                                <li className="fl-bullets">Automate provisioning, monitoring, and control from your UI</li>
                                <li className="fl-bullets">Offer a native API Management experience to your customers</li>
                                <li className="fl-bullets">Seamlessly connect to your CRM, billing, and service catalog</li>
                                </ul>
                                <br/>
                            <p className="fl-text">
                            <strong style={{ fontWeight: 600 }}>Best for:</strong> Self-service platforms and tech providers with their own customer-facing portals.
                            </p>
                        </div>
                        <div className="col-md-6 pl-5">
                            <img
                                src={icn_mision}
                                alt="Icon of arrows representing mission."
                                className="mb-3 aboutIcon"
                               
                            />
                            <h3 className="fl-subtitle">2. Reseller Model</h3>
                            <p className="fl-text">
                            Distribute AVAP API Management as a ready-to-use platform:
                            </p>
                        
                                <ul className="fl-bullets fl-text  .fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">Control users, environments, consumption, and billing</li>
                                <li className="fl-bullets">Access to multitenant environments and centralized management</li>
                                <li className="fl-bullets">Full support and operations handled by AVAP experts</li>
                                </ul>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                            <p className="fl-text">
                            <strong style={{ fontWeight: 600 }}>Best for:</strong> Infrastructure providers looking to add robust services without complex development.
                            </p>  
                        </div>
                          
                        <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                    </div>
                            </section>*/}

                {/*Sección Tipos de Deployments */}
                <div className="container fl-gradientContainer my-5 p-5">
                <div className="fl-title text-center mb-6">
                EDA & RTE
                <p className="fl-subtitle text-center m-0 gradient-text">One Scalable Platform.</p>
                </div>
            
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        {item.paragraphs2.map((p, i) => (
                            <p key={i} className="fl-text bold pt-4">{p}</p>
                        ))}
                        {item.bullets && (
                            <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: '7px' }}>
                            {item.bullets.map((b, i) => (
                                <li key={i} className="fl-bullets">{b}</li>
                            ))}
                            </ul>
                        )}
                        {item.paragraphs3.map((p, i) => (
                            <p key={i} className="fl-text bold pt-4">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                
                </div>

                {/*Sección Use Cases - bento */}
                <div className="container my-5 pt-4">
                <div className="fl-title text-center mb-4 fl-txt-container-s">
                How Does AVAP Framework Empower EDA & RTE?
                </div>
                <p className='fl-txt-container-s text-center pb-4'>AVAP is built to natively support APIs and event-driven flows that create fully reactive, governed digital ecosystems. With AVAP, organizations can:</p>

                    <Masonry
                    breakpointCols={breakpointColumnsObj2}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items2.map((item2, idx) => (
                        <div key={idx} className="grayBox fl-card text-center">
                        <img src={item2.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item2.title}</p>
                        {item2.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>
                


                {/* Sección built for secure */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="text-center">
                                    <h3 className='fl-title pb-4'>Why AVAP?</h3>
                                    <p>EDA and RTE are no longer optional trends, they are strategic imperatives for organizations striving to compete with speed, precision, and autonomy in the digital economy. 
                                    </p>
                                    <p className='bold pt-4'>AVAP Framework provides all the building blocks to make that vision a reality from day one, enabling you to build systems that are reactive by design and productive by nature. 
                                    {/*Boton Contact Us*/}  
                                    <a className="glowBtn-dark" style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">Contact Us  </span></a>
                                    </p>
                                    
                                    {/* Sección Bullets */}
                                    {/*<ul className="fl-bullets fl-text  .fl-txt-container-s " >
                                    <li className="fl-bullets">Compatible with Node.js, Java, Python, .NET, Go, and other API languages</li>
                                    <li className="fl-bullets">Integrates with OAuth2, OIDC, LDAP, and enterprise security protocols</li>
                                    <li className="fl-bullets">Works with Postman, Swagger/OpenAPI, GitHub, Jenkins, Bitbucket, and more</li>
                                    <li className="fl-bullets">Expandable with the AVAP ecosystem: AVAP CLI, Publisher, ID, Marketplace, and beyond</li>
                                    </ul>*/}
                                    

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default EdaRTE;
